import { Col, Row } from "antd";
import SectionHeader from "@/shared/components/assessment/report/SectionHeader/SectionHeader";
import CompositeCard from "@/shared/components/assessment/CompositeCard/CompositeCard";
import style from "./style.module.css";
import { InfoCircleFilled } from "@ant-design/icons";
import { IAssessmentComposite } from "@/modules/assessments/hooks/use-get-assessment-composites-by-invite.hook";
import IndicatorsSection from "@/shared/components/assessment/Indicators/IndicatorsSection";
import { AssessmentRating } from "@/shared/components/assessment/AssessmentRating/AssessmentRating";

interface IInterviewsProps {
  templateComposites: IAssessmentComposite[];
}

export default function Interviews({ templateComposites }: IInterviewsProps) {
  const composites = templateComposites.filter((composite: IAssessmentComposite) => !composite.isOverall);

  return (
    <Row className={style.interviewsContainer}>
      <SectionHeader title="Interview Guide" />
      <div className={style.helpText}>
        <InfoCircleFilled className={style.helpIcon} />
        <p>
          Use the questions to learn more about job-specific areas, as needed. Compare candidate responses to the
          indicators to evaluate.
        </p>
      </div>
      {composites.map((composite) => {
        if (!composite.interviewGuide) return null;

        return (
          <Col key={`${composite.compositeKey}-interview-guide`} span={24} className={style.interviewSection}>
            <CompositeCard cardClassName={style.autoHeightCard} composite={composite} showInterviewGuide />
            <section className={style.notesSection}>
              <h3 className={style.notesTitle}>Notes:</h3>
              <div className={style.notesSpace} aria-label="Space for handwritten notes" />
            </section>
            <IndicatorsSection
              compositeKey={composite.compositeKey}
              negativeItems={composite.interviewGuide.negativeIndicators}
              positiveItems={composite.interviewGuide.positiveIndicators}
            />
            <AssessmentRating />
          </Col>
        );
      })}
    </Row>
  );
}
